<template>
  <div class="modal fade" tabindex="-1" role="dialog" ref="mdlSeleccionarCotizacion">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header text-center">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
          <h3 class="modal-title">Seleccione cotización para generar orden de compra</h3>
        </div>
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table-hover align-middle">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Fecha de elaboración</th>
                  <th>Nombre de la cotización</th>
                  <th style="width:50px">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    1035
                  </td>
                  <td>
                    31/05/2020
                  </td>
                  <td>
                    Cotización para requerimiento 1035
                  </td>
                  <td>
                    <router-link
                      data-dismiss="modal"
                      :to="{ name: 'nuevoOrdenCompra', query: { id_cotizacion:10 } }"
                      class="btnInfo btn btn-default btn-xs"
                    >
                      <i class="fa fa-check"></i>
                      Seleccionar
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>

export default {  
  data: function() {
    return {
    
    }
  },
  methods: {
    mostrar() {
      var self = this
      $(self.$refs.mdlSeleccionarCotizacion).modal("show")
      //self.cargarArticulo()
    },

    cargarArticulo: function() {
      
    }
  }
}
</script>


<style scoped>
.color-verde {
  color: #1AB394
}
</style>
